import {
  ApiErrorResponse,
  GetApiErrorMessage,
  Modal,
  ModalWrapper,
  ValidationMessagesMap,
} from '@atlas-frontend/sdk';

interface WarningConfirmation {
  title: string;
  okText: string;
  cancelText: string;
  onOk: () => void;
  onCancel: () => void;
}

export function confirmInputDataWarnings(
  apiErrorResponse: ApiErrorResponse,
  translate: GetApiErrorMessage,
  { title, okText, cancelText, onOk, onCancel }: WarningConfirmation,
): boolean {
  const errors = ValidationMessagesMap.fromApiErrors(
    apiErrorResponse.response?.data.errors || [],
    translate,
  );
  if (errors.totalErrors || !errors.totalWarnings) {
    return false;
  }

  const warnings = [...errors.entries()].flatMap(([, messages]) =>
    messages.map(({ message }) => message),
  );
  Modal.confirm({
    title,
    okText,
    cancelText,
    content: (
      <ModalWrapper>
        {warnings.map((warning, index) => (
          <div key={index}>{warning}</div>
        ))}
      </ModalWrapper>
    ),
    onOk,
    onCancel,
  });
  return true;
}
